"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ObjectivesClient_1 = require("client/ObjectivesClient");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importStar(require("components/design-system/Modal"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const Footer = ({ closeCurrentModal, submitLink }) => {
    const { closeModal } = (0, Modal_1.useModal)() || {};
    const exitModal = () => {
        closeCurrentModal();
        closeModal?.();
    };
    const removeJira = async () => {
        await submitLink();
        exitModal();
    };
    return (react_1.default.createElement(Modal_1.default.Footer, { useBorder: false, primaryButton: {
            text: 'Remove',
            onClick: removeJira
        }, secondaryButton: {
            text: 'Cancel',
            onClick: exitModal
        } }));
};
const ModalRemoveJira = ({ closeCurrentModal, objectiveId, objectiveChildrenCount, currentIntegration, type, removeCurrentJira }) => {
    const [includeSubgoals, setIncludeSubgoals] = (0, react_1.useState)(false);
    const { refetchObjective, refetchSubObjectives } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const submitLink = async () => {
        if (type == 'create') {
            removeCurrentJira();
        }
        else {
            const params = {
                includeChildren: includeSubgoals
            };
            const { isSuccess } = await (0, ObjectivesClient_1.deleteJIRALink)(objectiveId, currentIntegration?.id, params);
            if (!isSuccess)
                return;
            refetchObjective(objectiveId);
            if (includeSubgoals) {
                refetchSubObjectives(objectiveId);
            }
        }
    };
    return (react_1.default.createElement(Modal_1.default, { customClass: "cursor-default w-[400px]", onClose: closeCurrentModal, minWidth: 184 },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Remove Link'), onClose: closeCurrentModal }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "flex flex-col mx-[24px]" },
                react_1.default.createElement("p", { className: "typography-paragraph text-n-900" }, (0, HelperUtils_1.getObjectiveLocale)('Are you sure you want to remove the link with Jira?')),
                currentIntegration?.importChildIssues && objectiveChildrenCount > 0 && (react_1.default.createElement("div", { className: "flex items-center mt-[20px] cursor-pointer", onClick: () => setIncludeSubgoals(!includeSubgoals) },
                    react_1.default.createElement(Checkbox_1.default, { name: "include-subgoals", id: "include-subgoals", checked: includeSubgoals, onClick: () => setIncludeSubgoals(!includeSubgoals), customContainerClass: "!min-h-[24px]" }),
                    react_1.default.createElement("p", { className: "typography-paragraph text-n-800 ml-[8px]" }, (0, HelperUtils_1.getObjectiveLocale)('Include link removal for Jira-linked subgoals')))))),
        react_1.default.createElement(Footer, { closeCurrentModal: closeCurrentModal, submitLink: submitLink })));
};
exports.default = ModalRemoveJira;
